import { decamelizeKeys } from "humps";
import ReactOnRails from "react-on-rails";

export default {
  claimOwnership(userEmail, orderConfirmationToken) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/orders/claim_ownership",
        type: "POST",
        data: decamelizeKeys({ userEmail, orderConfirmationToken }),
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  },

  sendGiftEmail(confirmationNumber) {
    // Since we are making a request to a non-API JSON action, we need a CSRF token.
    const authenticityToken = ReactOnRails.authenticityToken();

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/orders/send_gift_email_only",
        type: "POST",
        data: decamelizeKeys({ confirmationNumber, authenticityToken }),
        success: response => resolve(response),
        error: response => reject(response.responseText)
      });
    });
  }
}